import React, { useEffect, useState } from 'react';
import Button from '../button';
import PageHeader from '../page-header';
import './editor-newsletter-picker.css';

const identifierPattern = /^[a-z0-9_-]+$/;

const removePlaceholderDelimiters = value => value
  .replaceAll('[', '')
  .replaceAll(']', '');

const escapeHtml = value => value
  .replaceAll('&', '&amp;')
  .replaceAll('<', '&lt;')
  .replaceAll('>', '&gt;')
  .replaceAll('"', '&quot;')
  .replaceAll("'", '&#039;');

const EditorNewsletterPicker = () => {
  const [insertEvent, setInsertEvent] = useState(null);
  const [identifier, setIdentifier] = useState('');
  const [title, setTitle] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleInsertEvent = e => {
      setIdentifier('');
      setTitle('');
      setError(null);
      setInsertEvent(e);
    };

    document.addEventListener('EditorInsertNewsletter', handleInsertEvent);

    return () => document.removeEventListener('EditorInsertNewsletter', handleInsertEvent);
  }, []);

  if (insertEvent === null) {
    return <></>;
  }

  const handleCancel = () => setInsertEvent(null);

  const handleInsert = () => {
    const normalizedIdentifier = identifier.trim().toLowerCase();

    if (!identifierPattern.test(normalizedIdentifier)) {
      setError('Utilisez uniquement des minuscules, chiffres, tirets ou underscores.');
      return;
    }

    const normalizedTitle = removePlaceholderDelimiters(title.trim());
    const titlePart = normalizedTitle ? `|${escapeHtml(normalizedTitle)}` : '';

    insertEvent.detail.onPick(`<p>#[newsletter-${normalizedIdentifier}${titlePart}]</p>`);
    setInsertEvent(null);
  };

  return (
    <div className="editor-newsletter-picker">
      <div className="editor-newsletter-picker_overlay" onClick={handleCancel}></div>
      <div className="editor-newsletter-picker_wrapper">
        <div className="editor-newsletter-picker_container">
          <PageHeader title="Insérer une newsletter" />

          <div className="editor-newsletter-picker_content">
            <label className="editor-newsletter-picker_label" htmlFor="editor-newsletter-picker-identifier">
              Identifiant
            </label>
            <input
              autoFocus
              className="editor-newsletter-picker_input"
              id="editor-newsletter-picker-identifier"
              onChange={e => {
                setIdentifier(e.target.value);
                setError(null);
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleInsert();
                }
              }}
              placeholder="exemple-newsletter"
              type="text"
              value={identifier}
            />
            <p className="editor-newsletter-picker_help">Minuscules, chiffres, tirets ou underscores. Sans espace.</p>
            {error && <p className="editor-newsletter-picker_error">{error}</p>}

            <label className="editor-newsletter-picker_label" htmlFor="editor-newsletter-picker-title">
              Titre
            </label>
            <input
              className="editor-newsletter-picker_input"
              id="editor-newsletter-picker-title"
              onChange={e => setTitle(e.target.value)}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleInsert();
                }
              }}
              placeholder="Inscrivez-vous à la newsletter spéciale de Actualitté :"
              type="text"
              value={title}
            />
            <p className="editor-newsletter-picker_help">Laissez vide pour utiliser le texte par défaut.</p>

            <div className="editor-newsletter-picker_actions">
              <Button label="Annuler" onClick={handleCancel} type="button" />
              <Button label="Insérer" onClick={handleInsert} theme="success" type="button" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditorNewsletterPicker;
